var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("p", { staticClass: "px-4" }, [_vm._v(_vm._s(_setup.texts.info))]),
      _setup.gridConfiguration
        ? _c(_setup.LfGridComponent, {
            attrs: {
              gridConfiguration: _setup.gridConfiguration,
              itemData: _setup.professionals,
              toolbarOptions: _setup.toolbarOptions,
              contextMenuItems: _setup.contextMenuItems,
              commandClick: _setup.onCommandClick,
            },
            on: {
              toolbarClicked: _setup.onToolbarClick,
              contextMenuClicked: _setup.onContextMenuClicked,
            },
          })
        : _vm._e(),
      _c(_setup.PromptDialogComponent, {
        attrs: {
          title: _setup.modalTitle,
          formSchema: _setup.formSchema,
          formFieldValues: _setup.formData,
          isOpened: _setup.openedPrompt,
          width: 940,
          context: _setup.props.formAlias,
        },
        on: { "execute-action": _setup.onExecuteAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }